var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMenu = function SvgMenu(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H28C30.2091 0 32 1.79086 32 4V28C32 30.2091 30.2091 32 28 32H4C1.79086 32 0 30.2091 0 28V4Z",
    fill: "#1D386C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00006 11.0001C7.00006 10.4478 7.44778 10.0001 8.00006 10.0001L24.0001 10.0001C24.5523 10.0001 25.0001 10.4478 25.0001 11.0001C25.0001 11.5523 24.5523 12.0001 24.0001 12.0001H8.00006C7.44778 12.0001 7.00006 11.5523 7.00006 11.0001ZM7.00006 16.0001C7.00006 15.4478 7.44778 15.0001 8.00006 15.0001H24.0001C24.5523 15.0001 25.0001 15.4478 25.0001 16.0001C25.0001 16.5523 24.5523 17.0001 24.0001 17.0001H8.00006C7.44778 17.0001 7.00006 16.5523 7.00006 16.0001ZM8.00006 20.0001C7.44778 20.0001 7.00006 20.4478 7.00006 21.0001C7.00006 21.5523 7.44778 22.0001 8.00006 22.0001H20.0001C20.5523 22.0001 21.0001 21.5523 21.0001 21.0001C21.0001 20.4478 20.5523 20.0001 20.0001 20.0001H8.00006Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMenu, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Menu.c04f4c2a.svg";
export { ForwardRef as ReactComponent };